import { ReactComponent as NoteSvg } from "../../assets/noteUpdated.svg";

const NoteIcon = ({
  size = 40,
  color = "black",
}: {
  size?: number;
  color?: string;
}) => {
  return <NoteSvg width={size} height={size} style={{ color }} />;
};

export default NoteIcon;
